module.exports = __webpack_public_path__ + "static/media/296141.412c7e20.jpg";